import {makeRequest} from "../common";

export default function profilePageScripts() {

    $(document)
        .on('click', '.js-user-toggle-handler', _toggleCard)
        .on('input', '#pp--login-phone', _toggleSubmitClickOnEnter)
        .on('click', '#js-send-sms', _sendSMSCodeHandler);

    $('#pp--login-phone').mask("+38 (099) 999-99-99", { autoclear: true }).focus();

};

let ERROR_TEXT = document.querySelector('.pp--login_error');

let smsObject = {
    type: 'authPhone',
    user_phone: null
};

const SECOND_STEP_TMPL = `<div class="pp--login_relative"><input id="pp--login-code" class="pp--login_input" type="text" name="code" placeholder="Код з SMS"><span class="pp--login_error"></span></div><input id="js-send-auth" class="pp--login_submit" type="submit" value="Увiйти">`;

const _toggleCard = (e) => {
    let target = e.currentTarget,
        list = $(target).closest('.pp--user_ct').find('.js-user-toggle'),
        nextName = target.getAttribute('data-alt');

    list.each((i,e) => {
        $(e).toggleClass('isClose');
    });

    target.setAttribute('data-alt', target.innerHTML);

    target.innerHTML = nextName;
};

const _toggleSubmitClickOnEnter = (e) => {
    if (e.keyCode === 13)
        _sendSMSCodeHandler();
};

const _sendSMSCodeHandler = () => {
    let value = $('#pp--login-phone').val();
    ERROR_TEXT = document.querySelector('.pp--login_error')

    if ((value && value.length > 0) || smsObject.user_phone) {
        if (!smsObject.user_phone) smsObject.user_phone = value;

        makeRequest('POST', '/profile/', JSON.stringify(smsObject)).then((resolve) => {
            let rs = JSON.parse(resolve);
            if (rs.status === 1) {
                ERROR_TEXT.innerHTML = rs.error;
                delete smsObject.user_phone;
            } else {
                _secondStep();
            }
        }, (reject) => {
            ERROR_TEXT.innerHTML = 'Сталося помилка, спробуйте ще раз';
        });
    } else {
        $('#pp--login-phone').addClass('error').focus();
        ERROR_TEXT.innerHTML = 'Введiть правильний номер телефону';
    }
};

const _secondStep = () => {
    $(document)
        .off('click', '#js-send-sms', _sendSMSCodeHandler);

    const container = document.querySelector('.js-login-form-ct');
    if (container)
        container.innerHTML = SECOND_STEP_TMPL;

    setTimeout(() => {
        let div = document.createElement('div');

        div.className = 'pp--login_submit-ct';
        div.innerHTML = '<input id="js-send-sms" class="pp--login_submit" type="submit" value="Отримати код заново">';
        container.appendChild(div);
        div.querySelector('#js-send-sms').addEventListener('click', _sendSMSCodeHandler);
    }, 30000);

    $('#pp--login-code').focus();

    $(document)
        .on('input', '#pp--login-code', _toggleAuthClickOnEnter)
        .on('click', '#js-send-auth', _sendAuthHandler);
};

const _toggleAuthClickOnEnter = (e) => {
    if (e.keyCode === 13)
        _sendAuthHandler();
};

const _sendAuthHandler = () => {
    let error_text = document.querySelector('.pp--login_error');
    let value = $('#pp--login-code').val();

    if (value && value.length >= 3) {
        let obj = {
            type: "authCode",
            user_code: value
        };

        makeRequest('POST', '/profile/', JSON.stringify(obj)).then((resolve) => {
            let obj = JSON.parse(resolve);
            window.obj = obj;
            if (obj.status === 0) {
                window.location.reload();
            } else {
                _secondStep();
            }
        }, (reject) => {
            error_text.innerHTML = 'Неправильний код з SMS';
        });
    } else {
        $('#pp--login-code').addClass('error').focus();
        error_text.innerHTML = 'Введiть правильний код з SMS';
    }
};